export default function SignInUp({signInUp,children}){
    return  <div className={signInUp}>
        {children}
    </div>
}